import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: fit-content;
  padding-bottom: 1.5rem;
  margin-top: 2.8vh;
  border-radius: 0.8vw;
  user-select: none;

    width: 100%;
`

export const HeaderDiv = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-left: 1.1rem;
  margin-right: 1.1rem;
  min-height: 2rem;
  justify-content: space-between;
  align-items: center;
`

export const HeaderTipWithTitle = styled.div`
  display: flex;
  align-items: center;
  gap: .3rem;
`

export const HeaderText = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 700;
  font-size: clamp(1rem, calc(1rem + 0.2vw) , 2.7rem);
  font-family: 'Inter', sans-serif;
`

export const HeaderTip = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .4rem .8rem;
  font-weight: 400;
  border-radius: 1rem;
  gap: .6rem;
  
  &.out{
    color:#9D7D07;
    background-color: #FFFCEE;
  }

  &.in{
    color: #67C97E;
    background-color:rgba(179, 228, 191, 0.3);
  }

  img{
    width: 1rem;
  }
`

export const ViewMinMaxImg = styled.img`
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 3rem;
`